import PhoneInput from 'react-phone-input-2';
import '../styles/input-phone.css';

export default function InputPhone({ placeholder, validationLabel, value, name, onChange, label }) {

    const inputStyle = {
        backgroundColor: validationLabel? "#dc35454d" : "",
        borderBottom: validationLabel?"1px solid #dc3545" : "" 
    }

    const inputProps = {
        className: "min-h-10 placeholder:text-gray outline-none border-b border-[#504343] bg-[#f5f5f5] pr-2 pl-10 w-full text-md focus:bg-[#ebebeb]",
        placeholder: placeholder
    }

    return (
        <div className="relative w-full">
            <PhoneInput country="be" value={value} inputProps={inputProps} inputStyle={inputStyle} onChange={onChange} name={name}/>
            <label className="absolute top-0 right-1 text-red text-xs" htmlFor={name} >{validationLabel}</label>
            <p className="text-gray text-xs">{label}</p>
        </div>
    )
}